const dataSectionAddress = {
  title: 'Domicilio personal actual',
  label: {
    dirección: 'Dirección',
    bloque: 'Bloque',
    piso: 'Piso',
    escalera: 'Escalera',
    puerta: 'Puerta',
    cp: 'CP',
    poblacion: 'Población',
    provincia: 'Provincia',
    pais: 'País',
    telefono: 'Teléfono',
    email: 'Correo Electrónico'
  }
};

const userAddress = {
  addressConfirm: {
    title: 'TU SOLICITUD DE CAMBIO DE DOMICILIO PERSONAL HA SIDO ENVIADA',
    txt: 'En breve te confirmaremos la actualización de los datos.',
    btn: 'Volver a mis datos'
  },
  addressForm: {
    title: 'Solicitud de cambio de domicilio personal',
    btn: 'Enviar solicitud',
    fields: {
      tipoDeVia: {
        label: 'Tipo de vía'
      },
      calle: {
        label: 'Calle'
      },
      numero: {
        label: 'Número'
      },
      bloque: {
        label: 'Bloque'
      },
      escalera: {
        label: 'Escalera'
      },
      piso: {
        label: 'Piso'
      },
      puerta: {
        label: 'Puerta'
      },
      cpostal: {
        label: 'CP'
      },
      poblacion: {
        label: 'Población'
      },
      provincia: {
        label: 'Provincia'
      },
      pais: {
        label: 'País'
      },
      telefono: {
        label: 'Teléfono'
      },
      email: {
        label: 'Correo electrónico'
      }
    }
  },
  breadcrumb: {
    first: 'Mis datos',
    second: 'Solicitar cambio de domicilio'
  },
  editButton: 'SOLICITAR CAMBIO DE DOMICILIO',
  backButton: 'VOLVER',
  pending: 'Tienes una solicitud de cambio de domicilio pendiente de validar'
};

const bankAccount = {
  bankAccountConfirm: {
    title: 'TU SOLICITUD DE CAMBIO DE DOMICILIACIÓN BANCARIA HA SIDO ENVIADA',
    txt: 'En breve te confirmaremos la actualización de los datos.',
    btn: 'Volver a mis datos'
  },
  bankAccountForm: {
    title: 'Solicitud de cambio de domiciliación bancaria',
    label: 'Nuevo IBAN',
    btn: 'Enviar solicitud',
    errorMessage: 'El código IBAN no es correcto.'
  },
  bankAccountBreadcrumb: {
    first: 'Mis datos',
    second: 'Solicitar cambio de banco'
  },
  bankAccountPending:
    'Tienes una solicitud de cambio de domiciliación bancaria pendiente de validar',
  bankAccountBtn: 'SOLICITAR CAMBIO DE BANCO',
  bankAccountBackBtn: 'VOLVER',
  bankAccountResume: {
    title: 'DOMICILIO PERSONAL ACTUAL'
  },
  label: {
    agencyName: 'Banco',
    ibanCode: 'IBAN',
    bicCode: 'Código BIC',
    address: 'Domicilio',
    population: 'Población',
    province: 'Provincia'
  }
};

export { dataSectionAddress, userAddress, bankAccount };
